export default "__VITE_ASSET__ad8b74a7__"